export const timeZone = 'America/New_York';

export const currency = {
	locale: 'en-US',
	code: 'USD',
	precision: 2,
};
